export default __webpack_public_path__ + "static/media/1_12.8319f33c.png";